import React, { useState} from 'react';
import './AbonneForm.css';
import {
    validateStructureInfo,
    validateStructureIdentificationInfo,
  } from '../../utils/validation';
import { initialServiceFormData } from './../../utils/formData';

function StructureForm() {
const [currentStep, setCurrentStep] = useState(1);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(initialServiceFormData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };

    const validateFields = () => {
        let newErrors = {};

        if (currentStep === 1) {
        newErrors = validateStructureInfo(formData);
        }

        if (currentStep === 2) {
        newErrors = validateStructureIdentificationInfo(formData);
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleNext = () => {
        if (validateFields()) {
        setCurrentStep(currentStep + 1);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFields()) {
        alert('Formulaire envoyé avec succès');
        }
    };

        
    const handleBack = () => {
        setCurrentStep(currentStep - 1);
    };

  return (
    <div className="inscription-container">
      <form onSubmit={handleSubmit} className='inscription-form'>
        {currentStep === 1 && (
          <div className="form-step">
            <h2 className='inscription-title'>Informations du structure</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom structure</label>
                    <input type="text" name="nomStructure" value={formData.nomStructure} onChange={handleChange} placeholder="Entrez le Nom du structure...." />
                    {errors.nomStructure && <p className="error">{errors.nomStructure}</p>}
                </div>
                <div className="form-group">
                    <label>Adresse structure</label>
                    <input type="text" name="adresseStructure" value={formData.adresseStructure} onChange={handleChange} placeholder="Entrez l'adresse du structure...." />
                    {errors.adresseStructure && <p className="error">{errors.adresseStructure}</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name='email' value={formData.email} onChange={handleChange} placeholder="Entrez l'email"  required />
                    {errors.email && <p className="error">{errors.email}</p>}
                </div>
                <div className="form-group">
                    <label>Numéro de téléphone de l'institut</label>
                    <input type="tel" name="telephone" value={formData.telephone} onChange={handleChange} placeholder="+223 ..." />
                    {errors.telephone && <p className="error">{errors.telephone}</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Type de structure</label>
                    <input type="text" name="typeStructure"
                        value={formData.typeStructure}
                        onChange={handleChange} placeholder="Entrez le type du structure..." />

                    {errors.typeStructure && <p className="error">{errors.typeStructure}</p>}
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="info-supplementaire">Info supplémentaire</label>
                <textarea id="info-supplementaire" placeholder="Les autres Informations"></textarea>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="form-step">
            <h2 className='inscription-title'>Informations d'identification</h2>
            <div className="form-row">
                <div className="form-group">
                <label>Nom d'utilisateur</label>
                <input type="text" name="username"
              value={formData.username}
              onChange={handleChange} placeholder="Entrez le nom d'utilisateur" />
              {errors.username && <p className="error">{errors.username}</p>}
                </div>
                <div className="form-group">
                <label>Mot de passe</label>
                <input type="password" name="password"
              value={formData.password}
              onChange={handleChange} placeholder="Entrez le mot de passe" />
              {errors.password && <p className="error">{errors.password}</p>}
     
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                <label>Nom du contact principal</label>
                <input type="text" name="nomContact"
              value={formData.nomContact}
              onChange={handleChange} placeholder="Entrez le Nom du contact principal" />
              {errors.nomContact && <p className="error">{errors.nomContact}</p>}
                </div>
                <div className="form-group">
                <label>Poste au sein de l'institution</label>
                <input type="text" name="posteContact"
              value={formData.posteContact}
              onChange={handleChange} placeholder="Entrez le mot de passe" />
              {errors.posteContact && <p className="error">{errors.posteContact}</p>}
                </div>
            </div>
          </div>
        )}

        <div className="form-navigation">
        {currentStep > 1 && (
            <button type="button" onClick={handleBack} className="back-button">
            Retour
            </button>
        )}
        {currentStep < 2 ? (
            <button type="button" onClick={handleNext} className="next-button">
            Suivant
            </button>
        ) : (
            <button type="submit" className="submit-button">
            Enregistrer
            </button>
        )}
        </div>
      </form>
    </div>
  )
}

export default StructureForm